import { useState } from "react";
import styles from "./UserAvatar.module.css";
import noImg from "../../../../../assets/img/no-images.jpg"; // Fallback image path
const UserAvatar = ({ src, alt }: { src: string; alt: string }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className={styles.avatarContainer}>
      {/* 1. The Skeleton Loader (shows only while isLoaded is false) */}
      {!isLoaded && <div className={styles.skeletonAvatar}></div>}

      {/* 2. The Actual Image */}
      <img
        src={src}
        alt={alt}
        className={`${styles.avatarImage} ${isLoaded ? styles.visible : styles.hidden}`}
        onLoad={() => setIsLoaded(true)} // Toggle state when finished
        onError={(e) => {
          e.target.src = noImg; // Fallback image on error
          setIsLoaded(true); // Stop showing skeleton even on error
        }}
      />
    </div>
  );
};

export default UserAvatar;
